import { render, staticRenderFns } from "./Workday.vue?vue&type=template&id=d474b606&scoped=true"
import script from "./Workday.vue?vue&type=script&lang=js"
export * from "./Workday.vue?vue&type=script&lang=js"
import style0 from "./Workday.vue?vue&type=style&index=0&id=d474b606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d474b606",
  null
  
)

export default component.exports